import type firebaseAdmin from 'firebase-admin'

export function isExecutedDirectly(importMetaUrl: string) {
  return importMetaUrl === 'file://' + process.argv[1]
}

export function partitionArray<T>(array: T[], size: number): T[][] {
  const partitions: T[][] = []
  for (let i = 0; i < array.length; i += size) {
    partitions.push(array.slice(i, i + size))
  }
  return partitions
}

export async function waitForFirestore(admin: firebaseAdmin.app.App) {
  const firestore = admin.firestore()

  const startedAt = Date.now()
  const timeout = 30000 // 30 seconds

  let waiting = true
  while (waiting) {
    try {
      // eslint-disable-next-line no-console
      console.log('Checking if Firestore emulator is running...')
      await firestore.listCollections()
      waiting = false
    } catch (error) {
      if (Date.now() - startedAt > timeout) {
        throw new Error('Firestore emulator did not start in time')
      }
      // eslint-disable-next-line no-console
      console.log('Waiting for Firestore emulator to start...')
      await new Promise((resolve) => setTimeout(resolve, 1000))
    }
  }
}
